import { render } from "./OrdersPage.vue?vue&type=template&id=d6238ad0&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=d6238ad0&lang=css"
import "./OrdersPage.vue?vue&type=style&index=1&id=d6238ad0&lang=css"
import "./OrdersPage.vue?vue&type=style&index=2&id=d6238ad0&lang=css"
import "./OrdersPage.vue?vue&type=style&index=3&id=d6238ad0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6238ad0"]])

export default __exports__